module.exports = __webpack_public_path__ + "static/img/anniu.bc4991f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anniu.png
// module id = b86I
// module chunks = 5